export default {"src":"/_next/static/media/ic_spectate.1b75fdd5.svg","height":933,"width":933,"blurWidth":0,"blurHeight":0};